import { takeEvery, takeLatest } from 'redux-saga/effects';
import { DRIVER_LOG_MODULE } from '../../../configs/moduleNames';
import {
  LOAD_DRIVER_LOG_BY_ID, LOAD_DRIVER_LOG_LIST,
  LOAD_DRIVER_LOG_LIST_ALL,
} from '../actions';
import loadDriverLogList from './loadDriverLogList';
import loadDriverCardById from './loadDriverCardById';
import loadDriverLogListAll from './loadDriverLogListAll';

export default function* watchClient() {
  yield takeLatest(DRIVER_LOG_MODULE + LOAD_DRIVER_LOG_LIST, loadDriverLogList);
  yield takeLatest(DRIVER_LOG_MODULE + LOAD_DRIVER_LOG_LIST_ALL, loadDriverLogListAll);
  yield takeEvery(DRIVER_LOG_MODULE + LOAD_DRIVER_LOG_BY_ID, loadDriverCardById);
}
